import { VContent } from 'vuetify/lib/components/VContent';
import { VFadeTransition } from 'vuetify/lib/components/transitions';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContent,[_c('div',{attrs:{"id":"core-view"}},[_c(VFadeTransition,{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1),_c('core-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }